import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import { Controller, useForm } from 'react-hook-form';
import { modalsButtonStyles } from '../../collums-constants/styles/stylesheets/buttonsStyles';
import { makeStyles, Button, TextField, FormControl } from '@material-ui/core';
import { toastr } from 'react-redux-toastr';
import NotificationApi from '../../api/NotificationApi';
import CancelContinueModal from '../../collums-components/components/common/CancelContinueModal';

const PreAfterCareModal = ({ visible, setVisibility, classes = {}, closeModal }) => {
    const globalStyles = makeStyles(modalsButtonStyles)();
    const { control, register, handleSubmit, errors } = useForm({});
    const [lossDataModal, setLossDataModal] = useState(false);

    useEffect(() => {
        const requiredFields = Object.keys(errors);

        if (requiredFields.length !== 0) {
            const messages = requiredFields.map(field => errors[field].message);

            toastr.error('Missing fields', messages.join(','));
        }
    }, [errors]);

    const handleAddNotification = async formData => {
        try {
            const notificationCreated = await NotificationApi.createNotification({
                ...formData,
                description: formData.description || ''
            });
            closeModal(notificationCreated._id);
        } catch (error) {
            toastr.error(error.data?.message || 'Something went wrong');
        }
    };

    return (
        <>
            <Modal
                isOpen={visible}
                onCancel={() => setLossDataModal(true)}
                onClose={() => setVisibility(false)}
                title={'New Pre/After Care'}
                id="preaftercare-form"
                size="xs"
                dialogClass={classes.modal}
            >
                <FormControl style={{ width: '100%' }}>
                    <Controller
                        render={props => (
                            <TextField
                                required
                                {...props}
                                className={classes.inputField}
                                variant="outlined"
                                label={'Name'}
                            />
                        )}
                        name={'name'}
                        control={control}
                        rules={register({ required: true })}
                    />
                    <Controller
                        render={props => (
                            <TextField
                                {...props}
                                className={classes.inputField}
                                variant="outlined"
                                label={'Description'}
                            />
                        )}
                        name={'description'}
                        control={control}
                    />

                    <div className={globalStyles.buttonsContainer}>
                        <Button className={globalStyles.cancelButton} onClick={() => setVisibility(false)}>
                            Cancel
                        </Button>
                        <Button
                            className={globalStyles.confirmButton}
                            type="submit"
                            variant="outlined"
                            onClick={() => {
                                handleSubmit(handleAddNotification)();
                            }}
                        >
                            Save
                        </Button>
                    </div>
                </FormControl>
            </Modal>
            <CancelContinueModal
                open={lossDataModal}
                onContinue={() => setVisibility(false)}
                onCancel={() => setLossDataModal(false)}
                closeOnBlur={false}
                title={'Your changes will not be saved'}
                contentText={'Are you sure you want to continue?'}
                cancelButtonText="Back"
            />
        </>
    );
};

export default PreAfterCareModal;
